import { Box, Button, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';

const useStyles = makeStyles((theme) => ({
  imageGridItem: {
    '& img': {
      minHeight: '100vh',
      objectFit: 'cover',
    },
    // hide image on medium and smaller screens
    [theme.breakpoints.down('xl')]: {
      display: 'none',
    },
  },

  contentGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',

    '& div > h5': {
      fontSize: '32px',
      textAlign: 'center',
      fontWeight: '800 !important',
      color: '#344767',
      letterSpacing: 'initial !important',

      '@media (max-width: 989px)': {
        fontSize: '28px',
      },
    },

    '& div:not(:first-child)': {
      padding: '0 20px',
    },

    '& div:not(:first-child) > p': {
      fontSize: '24px',
      textAlign: 'center',
      fontWeight: 400,
      color: '#344767',
      letterSpacing: 'initial !important',

      '@media (max-width: 989px)': {
        fontSize: '28px',
      },
    },

    '& > div': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '600px',
    },

    // make full width and center aligned when image grid hidden
    [theme.breakpoints.down('xl')]: {
      width: '100%',
      padding: theme.spacing(2),
    },
  },

  root: {
    backgroundColor: '#FFF',
    minHeight: '100vh',
  },

  logoBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '20px',

    '& p': {
      color: '#1088FD',
      fontWeight: 400,
      fontSize: '4em',
    },

    '& img': {
      maxWidth: '80px',
      maxHeight: '80px',
    },
  },

  rocketImg: {
    maxWidth: '250px',
    maxHeight: '250px',
    margin: '0 auto',
  },

  contentBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '15px',
    margin: '20px 0',
  },


  button: {
    backgroundColor: '#1088FD',
    color: '#FFF',
    borderRadius: '100px',
    padding: '24px 33px',
    fontWeight: 700,
    fontSize: '26px',
    textTransform: 'initial',
    letterSpacing: 'initial !important',

    '&:hover': {
      backgroundColor: '#1088FD !important',
    },

    '@media (max-width: 989px)': {
      fontSize: '20px',
    },
  },
}));

const V3SunsetInfoPage = () => {
  const classes = useStyles();
  const handleClick = () => {
    window.open(process.env.REACT_APP_SASSY_URL);
  };

  return (
    <Grid container className={classes.root}>
      <Grid item lg={7} className={classes.imageGridItem}>
        <img src='v3sunset.png' alt='V3 Sunset'/>
      </Grid>

      {/* Make full width on smaller screens */}
      <Grid item lg={5} xs={12} className={classes.contentGrid}>
        <Box>
          <Box className={classes.logoBox}>
            <img src='cropped-NKS-colour-siteicon2-1-180x180.png' alt='KS-logo'/>
            <Typography>KeepSpace</Typography>
          </Box>
          <Box className={classes.contentBox}>
            <img className={classes.rocketImg} src={'sunsetRocket.png'} alt={'Rocket'}/>
            <h5>Time to Update</h5>
            <Typography>This Version is no longer supported. <br/> Please continue in the new Version</Typography>
          </Box>
          <Button onClick={handleClick} className={classes.button}>
            Go to the new Version
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default V3SunsetInfoPage;
